import { useRef, type DetailedHTMLProps, type HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

import { DropdownContext } from "@/contexts/DropdownContext";
import { multiref } from "@/multiref";

export function Dropdown({
  children,
  className,
  ref,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  const divRef = useRef<HTMLDivElement | null>(null);

  return (
    <DropdownContext.Provider value={divRef}>
      <div
        ref={multiref(divRef, ref)}
        className={twMerge("flex-col rounded-sm bg-white shadow-lg open:flex", className)}
        {...props}
      >
        {children}
      </div>
    </DropdownContext.Provider>
  );
}
